import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet";
import { Typography, Card, Box } from "@mui/material";
import api from "../../globals/axios";
import { styled } from "@mui/system";
import { useTranslation } from "react-i18next";
import { getUserDetails } from "../../globals/authentication";
import AdvisoryIcon from "../../assets/Icon/AdvisoryIcon.png";
import GenericButton from "../../components/Custom/GenericButton";
import AdvisoryAnswerDialogBox from "../../components/AdvisoryAnswerDialogBox";
const StyledCard = styled(Card)``;

const MAX_QUESTION_LENGTH = 29;

const GreenDot = styled("span")({
  position: "absolute",
  display: "inline-block",
  width: "8px",
  height: "8px",
  borderRadius: "50%",
  backgroundColor: "#4CAF50",
  right: 20,
});

const QuestionsAskedCards = ({ questions, t }) => {
  const [selectedQuestion, setSelectedQuestion] = useState(null);
  const [openDialog, setOpenDialog] = useState(false);

  const handleCardClick = (question) => {
    if (question.answer) {
      setSelectedQuestion(question);
      setOpenDialog(true);
    }
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
    setSelectedQuestion(null);
  };

  return (
    <div>
      {questions.map((question) => (
        <StyledCard
          key={question.id}
          onClick={() => handleCardClick(question)}
          sx={{
            my: 1,
            borderRadius: 1,
            boxShadow: "none",
            border: question.answer ? "1px solid #4CAF50" : "1px solid #A5A5A5",
            position: "relative",
          }}
          elevation={2}
        >
          <Box sx={{ padding: 2 }}>
            {question.answer && <GreenDot />}
            <Typography color="textSecondary" gutterBottom>
              {t("Asked On")}:{" "}
              {new Date(question.created_at).toLocaleDateString()}
            </Typography>
            <Typography color="textSecondary" gutterBottom>
              {t("Question")}:{" "}
              {question.text.length > MAX_QUESTION_LENGTH
                ? `${question.text.slice(0, MAX_QUESTION_LENGTH)}...`
                : question.text}
            </Typography>
          </Box>
        </StyledCard>
      ))}
      {selectedQuestion && (
        <AdvisoryAnswerDialogBox
          open={openDialog}
          onClose={handleCloseDialog}
          question={selectedQuestion.text}
          answer={selectedQuestion.answer.translated_answer.text}
          date={selectedQuestion.created_at}
        />
      )}
    </div>
  );
};
export default function AdvisoryQuestions() {
  const [data, setData] = useState([]);
  const { t } = useTranslation();
  let user = getUserDetails();
  useEffect(() => {
    loadTasks();
  }, []);

  const loadTasks = async () => {
    api
      .get(`/advisory/questions/?asked_by=${user.app_user.id}`)
      .then((result) => {
        setData(result.data);
      })
      .catch((err) => {
        alert("Error: " + err.response.data.non_field_errors[0]);
      });
  };

  return (
    <>
      <Helmet>
        <title>Advisory Questions - Farmapp</title>
      </Helmet>
      {data.length !== 0 && (
        <div
          style={{
            height: "77vh",
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            overflow: "scroll",
          }}
        >
          <div
            style={{
              height: "100%",
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
              overflow: "scroll",
            }}
          >
            <QuestionsAskedCards questions={data} t={t} />
          </div>
          <GenericButton
            onClick={() => (window.location.href = "/advisory/create-question")}
            backgroundColor="#4CAF50"
            fontColor="white"
            borderColor="#388E3C"
            padding="8px 0"
            fontSize="14px"
            hideIcon
          >
            {t("Ask New Question")}
          </GenericButton>
        </div>
      )}

      {data.length === 0 && (
        <div
          style={{
            height: "70vh",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <div
            style={{
              margin: "auto",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <img
              src={AdvisoryIcon}
              alt="Advisory"
              style={{
                width: "127px",
                height: "127px",
                marginBottom: "10px",
              }}
            />

            <GenericButton
              onClick={() =>
                (window.location.href = "/advisory/create-question")
              }
              backgroundColor="#4CAF50"
              fontColor="white"
              borderColor="#388E3C"
              padding="8px 0"
              fontSize="14px"
              hideIcon
            >
              {t("Ask New Question")}
            </GenericButton>

            <Typography variant="subtitle1" sx={{ mb: 2, textAlign: "center" }}>
              {t("Your Questions will be displayed here once you add them.")}
            </Typography>
          </div>
        </div>
      )}
    </>
  );
}
